export default (ctx, inject) => {
  const registrationProgress = {
    get: async (part) => {
      // Only the scan-units step changes the unit set, and it is the only step
      // that needs the units themselves. The later steps read the stored count,
      // which saves a product range search on every screen of the flow.
      const units =
        part === 'scan-units'
          ? await ctx.store.dispatch('registration/getUnitsForOverview')
          : null
      const unitCount =
        units?.length ??
        (await ctx.store.dispatch('registration/getUnitCountForOverview'))

      // 01. how many units do we have to scan & are scanned
      // 02. commissioning date (not when we have code)
      // 03. building date (not when we have code)
      // 04. end user info
      // 05. end user & installation address
      // 06. service partner (not when we have code)
      // 07. remote support (only with a LAN adapter linked to a gateway)
      // 08. summary
      const cases = [
        'scan-units',
        'commissioning',
        'building-house',
        'end-user-personal-info',
        'end-user-address',
        'service-partner',
        'remote-support'
      ]
      const step = 90 / (unitCount + cases.length)
      let progress = 10

      switch (part) {
        case 'scan-units': {
          const scannedUnits = units.filter((u) => !!(u.material && u.serial))
          progress += step * scannedUnits.length
          break
        }
        default:
          progress += step * (unitCount + cases.indexOf(part))
          break
      }

      return progress
    }
  }

  ctx.$registrationProgress = registrationProgress
  inject('registrationProgress', registrationProgress)
}
